import React from "react";
import job from "../images/job.png";
import "./styles.css";
const Work = () => {
  return (
    <div className="section">
      <div className="row">
        <div className="col-xs-3" style={{ borderRadius: "50px!important" }}>
          <img src={job} alt="Job" style={{ borderRadius: "50%!important" }} />
        </div>
        <div className="col-xs-9">
          <div className="ptitle"> Current Work</div>

          <div className="pbody">
            <p>I am currently working as a Frontend Engineer at ShopTrade</p>
          </div>
        </div>
      </div>
    </div>
  );
};
export default Work;
